module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/saas-sketch-1-e6e0b47392cca6b1e8c116f8adc6d366.svg";